import axios from 'axios';
import ApiService from "@services/api.service";
import errorResponseHandler from '@services/api.error.service';

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        window.axios = axios;

        // Set the base URL of the API
        let baseUrl = process.env.MIX_VUE_APP_ROOT_API;
        if (window.location.protocol === 'https:' && baseUrl.startsWith('http:')) {
            baseUrl = baseUrl.replace('http:', 'https:');
        }
        ApiService.init(baseUrl);

        // Set default header
        ApiService.setDefaultHeaders();

        // apply interceptor on request
        axios.interceptors.request.use(function (config) {
            // Do something before request is sent

            // Start the progress bar
            Vue.prototype.$Progress.start();

            return config;
        }, function (error) {
            // Do something with request error
            return Promise.reject(error);
        });

        // apply interceptor on response
        axios.interceptors.response.use(
            response => {
                // Scroll to page top
                // window.scrollTo(0, 0);

                // End the progress bar
                Vue.prototype.$Progress.finish();

                if (_.has(response, 'data.status') && response.data.status != 200) {
                    response.status = response.data.status;
                    let res = _.cloneDeep(response);
                    res = _.set(res, 'status', res.data.status);
                    return errorResponseHandler(res);
                }
                // Return axios response
                return response
            },
            errorResponseHandler
        );

    }
}
